import type { CookieOptions } from 'nuxt/app';

/**
 * 쿠키 읽기, 쓰기 전역 함수 정의
 */
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  
  /*
  sameSite = 'none' 일 경우엔 secure = true로 설정해야함
  */
  const defaultOptions: CookieOptions & { readonly?: false | undefined } = {
    path: '/',
    secure: config.public.VITE_ENV_TYPE === 'local' ? false : true,
    sameSite: config.public.VITE_ENV_TYPE === 'local' ? 'lax' : 'none' as (boolean | "none" | "lax" | "strict" | undefined),
    //decode: undefined,
    //encode: undefined,
    //default: undefined,
    watch: true,
    readonly: false as (false | undefined),
  };
  
  // if (config.public.VITE_ENV_TYPE !== 'local') {
  //   defaultOptions.domain = '.ttobakcare.com';
  // }

  if (config.public.VITE_ENV_TYPE !== 'local') {
    if (import.meta.env.SSR) {
      // SSR:::::::::::
      const headers = useRequestHeaders();
      const host = headers['host'] || '';
  
      if (host.includes('ttobakcare.com')) {
        defaultOptions.domain = '.ttobakcare.com';
      } else if (host.includes('desimone.co.kr')) {
        defaultOptions.domain = '.desimone.co.kr';
      } else {
        defaultOptions.domain = host;
      }
    } else {
      // CSR:::::::::::
      const currentDomain = window.location.hostname;
  
      if (currentDomain.endsWith('.ttobakcare.com')) {
        defaultOptions.domain = '.ttobakcare.com';
      } else if (currentDomain.endsWith('.desimone.co.kr')) {
        defaultOptions.domain = '.desimone.co.kr';
      } else {
        defaultOptions.domain = currentDomain;
      }
    }
  }
  
  console.log("설정된 쿠키 도메인222222222222:::::::", defaultOptions.domain);
    
  /**
   * 쿠키 쓰기
   * @param name 이름
   * @param value 값
   * @param options 옵션
   */
  nuxtApp.provide('setCookie', (name: string, value: any, options: Record<string, any> = {}) => {
    // 유효기간 설정 
    if (options?.expires) {
      const date = new Date();
      date.setDate(date.getDate() + options.expires);
      options.expires = date;
    }
    
    const cookieOptions = { ...defaultOptions, ...options };
    useCookie(name).value = null;
    useCookie(name, cookieOptions).value = value;
  });
  
  /**
   * 쿠키 읽기
   * @param name 이름
   * @returns 값
   */
  nuxtApp.provide('getCookie', (name: string, options: Record<string, any> = {}) => {
    const cookieOptions = { ...defaultOptions, ...options };
    return useCookie(name, cookieOptions).value;
  })
});

declare module '#app' {
  interface NuxtApp {
    $defaultCookieOption: CookieOptions & { readonly?: false | undefined };
    $setCookie: (name: string, value: any, options?: Record<string, any>) => void;
    $getCookie: (name: string, options?: Record<string, any>) => any;
  }
}